import { Fade, Paper, Popper } from "@mui/material";
import { ReactNode, useEffect, useRef, useState } from "react";

const GalleryImageHover = ({
  src,
  alt,
  children,
}: {
  src: string;
  alt?: string;
  children: ReactNode;
}) => {
  const anchorRef = useRef<HTMLDivElement>(null);
  const closeTimeoutRef = useRef<ReturnType<typeof setTimeout>>();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }
    setOpen(true);
  };

  const handleClose = () => {
    closeTimeoutRef.current = setTimeout(() => setOpen(false), 100);
  };

  useEffect(() => {
    return () => {
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={anchorRef}
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onMouseEnter={handleOpen}
      onMouseLeave={handleClose}
    >
      {children}
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom"
        transition
        style={{ zIndex: 1600 }}
        modifiers={[
          { name: "offset", options: { offset: [0, 10] } },
          {
            name: "preventOverflow",
            options: { padding: 16, altAxis: true },
          },
          {
            name: "flip",
            options: {
              fallbackPlacements: ["top", "right", "left"],
            },
          },
        ]}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={180}>
            <Paper
              elevation={0}
              onMouseEnter={handleOpen}
              onMouseLeave={handleClose}
              sx={{
                borderRadius: "12px",
                overflow: "hidden",
                border: "1px solid var(--theme-border-color, rgba(0, 0, 0, 0.08))",
                boxShadow: "0 12px 32px rgba(0, 0, 0, 0.14)",
                bgcolor: "var(--theme-bg-primary, #ffffff)",
                p: "8px",
              }}
            >
              <div
                style={{
                  borderRadius: 8,
                  overflow: "hidden",
                  lineHeight: 0,
                  backgroundColor: "var(--theme-bg-secondary, #f5f5f5)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={src}
                  alt={alt || ""}
                  style={{
                    width: 500,
                    height: 500,
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              </div>
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  );
};

export { GalleryImageHover };
